import {SelectionModel} from '@angular/cdk/collections';
import {Platform} from '@angular/cdk/platform';
import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges,} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {Certificat, InfoOs, UmLgLoginQVO, UserCertifLogin,} from 'src/app/domain';

import {LoginService} from 'src/app/modules/services/user/login/login.service';
import {icons} from 'src/app/ui/icons';
import {CertificatDetailsComponent} from '../certificat-details/certificat-details.component';
import {ToastService} from '../../../modules/toast/toast.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ListUsersLoginComponent} from './list-users-login/list-users-login.component';
import {isEmpty} from 'src/app/utils/is-empty';
import {isSomeInputsChanged} from '../../../utils/ng-changes';
import {DatePipe} from '@angular/common';
import {SharedWsService} from '../../../modules/services/Common/shared-ws.service';
import {Pagination} from '../../../domain/search/Pagination';
import {environment} from '../../../../environments/environment';
import {SpinnerConfig} from '../../../domain/SpinnerConfig';
import {urlJoin} from '../../../utils/urlJoin';
import {downloadFileLocally} from '../../../utils/tools';
import * as moment from 'moment';

type Column = keyof Certificat | 'action';

@Component({
    selector: 'app-certificat-page',
    templateUrl: './certificat-page.component.html',
    styleUrls: ['./certificat-page.component.css'],
})
export class CertificatPageComponent implements OnInit {
    certiflocalbool: boolean = false;
    disabled_conn: boolean = true;
    isAuthenticating = false;
    @Input() portail = true;
    @Output() emitdata = new EventEmitter<any>();

    spinnerConfig: SpinnerConfig = new SpinnerConfig();


    paginationObject: Pagination = new Pagination(0, 5);
    certificates: Certificat[] = [];
    infooscert: InfoOs;
    list: any;
    icons = icons;
    @Input() certificatees: Certificat[];
    dataSource = new MatTableDataSource<Certificat>();
    displayedColumns: Column[] = [
        'commonName',
        'issuerCommonName',
        'notAfter',
        'action',
    ];
    labels: Partial<Record<Column, string>> = {
        commonName: 'Utilisateur',
        issuerCommonName: 'Emetteur',
        notAfter: 'Date d\'expiration',
    };
    selection = new SelectionModel<Certificat>(false, []);
    @Input() ondelete: boolean;
    certificatdetails: Certificat[] = [];
    name: string;
    securevalue: string = '';
    encdatavalue: string = '';
    userToConnect: UserCertifLogin = new UserCertifLogin();
    umLgLoginQVO: UmLgLoginQVO = new UmLgLoginQVO();

    constructor(private datePipe: DatePipe,
                private loginService: LoginService,
                public platform: Platform,
                private dialog: MatDialog,
                private router: Router,
                private toast: ToastService,
                private appTranslateService: AppTranslateService,
                private authService: LoginService,
                private sharedWs: SharedWsService,
                private toastService: ToastService
    ) {


    }

    get readColumns() {
        return this.displayedColumns.filter((column) => column !== 'action');
    }

    ngOnInit(): void {
        this.verifierLocal();
    }

    verifierLocal() {
        this.spinnerConfig.isLoading = true;
        this.loginService.getInfoCer().subscribe({
            next: (res) => {
               // console.log('res :: ',res)
                if(res.version=="3.1"){
                    this.infooscert = res;

                    this.certiflocalbool = true;
                    this.getAll();
                }
              else {
               // this.certiflocalbool = true;
                this.spinnerConfig.isLoading = false;
                this.toast.error('Veuillez vérifier la version actuelle du Local Server');
              }


            }, error: (e) => {
                this.spinnerConfig.isLoading = false;
                console.error('Error in CertificatPageComponent/verifierLocal, error:: ', e);
                this.toast.error('Problème de connexion avec le Local Server');
            }
        });
    }

    getAll() {
        this.loginService.getCer().subscribe({
            next: (res) => {
                this.spinnerConfig.isLoading = false;
                res.filter(column => {
                    let revSplitt = column.notAfter.split('-');
                    let datee;
                    if (this.getLan() == 'fr' || this.getLan() == 'en') {
                        datee = revSplitt[2] + '-' + revSplitt[1] + '-' + revSplitt[0];

                    } else {
                        datee = revSplitt[0] + '-' + revSplitt[1] + '-' + revSplitt[2];
                    }
                    column.notAfter = datee;


                });
                this.certificates = res;

                this.onPaginate();
            },
            error: (e) => {
                this.spinnerConfig.isLoading = false;
                console.error('Error in CertificatPageComponent/getAll, error:: ', e);
            }
        });
    }

    downloadLoacalServer() {
        const getLocalServerFileName = () => {
            if (navigator.appVersion.indexOf('Mac') != -1) { // MacOS
                return environment.localServer.fileName.Mac;
            }
            if (navigator.appVersion.indexOf('X11') != -1 || navigator.appVersion.indexOf('Linux') != -1) { // UNIX
                return environment.localServer.fileName.Unix;
            }
            return environment.localServer.fileName.Windows;
        };

        downloadFileLocally(urlJoin(environment.server.hostSource, 'gateway', `dowloadLocalServer?fileName=${getLocalServerFileName()}`), getLocalServerFileName());
    }

    getLocalSrverPath() {
        const getLocalServerFileName = () => {
            if (navigator.appVersion.indexOf('Mac') != -1) { // MacOS
                return environment.localServer.fileName.Mac;
            }
            if (navigator.appVersion.indexOf('X11') != -1 || navigator.appVersion.indexOf('Linux') != -1) { // UNIX
                return environment.localServer.fileName.Unix;
            }
            return environment.localServer.fileName.Windows;
        };

        downloadFileLocally(urlJoin(environment.server.hostSource, 'gateway', `dowloadLocalServer?fileName=${getLocalServerFileName()}`), getLocalServerFileName());
    }

    // downloadLoaclServer() {
    //     const getLocalServerFileName = () => {
    //         if (navigator.appVersion.indexOf('Mac') != -1) { // MacOS
    //             return environment.localServer.fileName.Mac;
    //         }
    //         if (navigator.appVersion.indexOf('X11') != -1 || navigator.appVersion.indexOf('Linux') != -1) { // UNIX
    //             return environment.localServer.fileName.Unix;
    //         }
    //         return environment.localServer.fileName.Windows;
    //     };
    //
    //
    //     const request: RequestObject = <RequestObject> {
    //         page: 'downloadLocalServer',
    //         reqParams: {
    //             fileName: getLocalServerFileName()
    //         },
    //         source: 'gateway', // from gateway
    //         method: 'GET',
    //         speCond: 'download-progress'
    //     };
    //
    //     this.spinnerConfig = new SpinnerConfig(true, 50, 'warn', 'determinate', 0, '0 %');
    //     this.sharedWs.commonWs(request).subscribe({
    //         next: (response) => {
    //             if (response.type === HttpEventType.DownloadProgress) {
    //                 const percentDone = Math.round(100 * response['loaded'] / response['total']);
    //                 this.spinnerConfig.value = percentDone;
    //                 this.spinnerConfig.msg = percentDone + ' %';
    //             } else if (response.type === HttpEventType.Response) {
    //                 this.spinnerConfig = new SpinnerConfig();
    //                 const blob: any = new Blob([response.body], {
    //                     type: 'application/octet-stream',
    //                 });
    //                 saveAs(blob, getLocalServerFileName());
    //                 this.toastService.success('Téléchargement effectué avec succès');
    //             }
    //         },
    //         error: (err) => {
    //             this.spinnerConfig = new SpinnerConfig();
    //
    //             this.toastService.error();
    //         },
    //         complete: () => {
    //             this.spinnerConfig = new SpinnerConfig();
    //         },
    //     });
    // }

    ngOnChanges(changes: SimpleChanges): void {
        const {certificatees} = changes;
        if (isSomeInputsChanged(changes, ['certificatees'])) {
            this.loadDataSource(certificatees.currentValue);
        }
    }

    getLan() {
        console.log('🚀 ~ file: certificat-page.component.ts ~ line 237 ~ CertificatPageComponent ~ getLan ~ this.appTranslateService.getDefaultLang()', this.appTranslateService.getDefaultLang());
        return this.appTranslateService.getDefaultLang();
    }

    loadDataSource(certificates: Certificat[]) {
        this.certificates = certificates;
        this.certificates.filter(column => {


            if (column.notAfter != undefined || column.notAfter != null) {
                this.datePipe.transform(column.notAfter, 'yyyy/MM/dd');
            }

        });
        this.onPaginate();
    }

    openCertif(certificat) {
        this.certificatdetails.push(certificat);

        const dialogRef = this.dialog.open(CertificatDetailsComponent, {
            data: {certificatdetails: this.certificatdetails},
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            width: '70vw',
        });
        dialogRef.afterClosed().subscribe((submit) => {
            this.certificatdetails = [];
            if (this.selection.isSelected) {
                this.disabled_conn = false;
            } else {
                this.disabled_conn = true;
            }
        });
    }

    toggle(row) {

        this.selection.selected.forEach((row) => {
            this.name = row.commonName;
        });

        this.disabled_conn = false;
    }

    login() {
        this.send();
        var today = new Date();
        console.log('this.selection.selected : ', this.selection.selected)
        const [ day,month, year] = this.selection.selected[0].notAfter.toString().split('-');
        let date = new Date(+year, +month-1 , +day);
        if(this.getLan()==='ar' ){
            date =new Date(+day, +month-1 , +year);
        }

        if (this.portail) {
            
            this.selection.selected.forEach((row) => this.name = row.commonName);
            console.log('exp : ',date)
            console.log('today : ',today)
            console.log('bool ',date <today)
            if(date <today){
            this.toast.error('Le certificat est expiré');
          }  
            else {
            this.isAuthenticating = true;
            this.loginService.getEncData(this.name).subscribe((encData) => {
                this.loginService.getListTestUsers(encData).subscribe({
                    next: (res) => {
                        res=res.payload
                        if (res.length > 1) {
                            res.filter((user) => {
                                if (user.userCl == 'g') {
                                    user.role = 'Acheteur';
                                } else if (user.userCl == 'c') {
                                    user.role = 'Fournisseur';
                                }
                            });

                            const dialogRef = this.dialog.open(ListUsersLoginComponent, {
                                disableClose: true,
                                direction: this.appTranslateService.getDir(),
                                width: '70vw',
                                data: {
                                    encData: encData,
                                    data: res,
                                },
                            });

                            dialogRef.afterClosed().subscribe((result) => {
                                if (!isEmpty(result)) {


                                    // this.loginService
                                    //     .getEncData(this.name)
                                    //     .subscribe((encData) => {
                                            this.loginService
                                                .getSecure(this.name)
                                                .subscribe((secure) => {

                                                    this.encdatavalue = encData;
                                                    this.userToConnect.encData = this.encdatavalue;
                                                    this.userToConnect.secu = secure;

                                                    sessionStorage.setItem(
                                                        'secu',
                                                        this.userToConnect.secu
                                                    );
                                                    sessionStorage.setItem('encData', this.encdatavalue);
                                                    this.userToConnect.fail = 'Y';
                                                    this.userToConnect.staffNm = result.data.staffNm;
                                                    this.userToConnect.masterCd = result.data.masterCd;
                                                    this.userToConnect.staffDepNm =
                                                        result.data.staffDepNm;
                                                    this.userToConnect.supplierNm =
                                                        result.data.supplierNm;
                                                    this.userToConnect.userCl = result.data.userCl;
                                                    this.userToConnect.userId = result.data.userId;
                                                    this.userToConnect.seq = result.data.seq;
                                                    this.userToConnect.testFl = result.data.testFl;
                                                    // this.userToConnect.umLgLoginQVO = this.umLgLoginQVO;
                                                    // console.log(
                                                    //     'test :::',
                                                    //     JSON.stringify(this.userToConnect)
                                                    // );

                                                    this.loginService.authenticate(this.userToConnect).subscribe((credentialsAreFine) => {
                                                            this.isAuthenticating = false;
                                                            if (credentialsAreFine) {
                                                                this.redirect();
                                                            } else {
                                                            }
                                                        }, () => {
                                                            this.isAuthenticating = false;
                                                            this.toast.error();
                                                        }
                                                    );
                                                });
                                        // });
                                }
                            });
                        } else if (res.length == 1) {
                            this.isAuthenticating = true;
                            // this.loginService.getEncData(this.name).subscribe((encData) => {
                                this.loginService.getSecure(this.name).subscribe((secure) => {

                                    this.encdatavalue = encData;
                                    this.userToConnect.encData = this.encdatavalue;
                                    this.userToConnect.secu = secure;

                                    sessionStorage.setItem('secu', this.userToConnect.secu);
                                    sessionStorage.setItem('encData', this.encdatavalue);
                                    this.userToConnect.fail = 'Y';
                                    this.userToConnect.staffNm = res[0].staffNm;
                                    this.userToConnect.masterCd = res[0].masterCd;
                                    this.userToConnect.staffDepNm = res[0].staffDepNm;
                                    this.userToConnect.supplierNm = res[0].supplierNm;
                                    this.userToConnect.userCl = res[0].userCl;
                                    this.userToConnect.userId = res[0].userId;
                                    this.userToConnect.seq = res[0].seq;
                                    this.userToConnect.testFl = res[0].testFl;
                                    // this.userToConnect.umLgLoginQVO = this.umLgLoginQVO;
                                    // console.log('test :::', JSON.stringify(this.userToConnect));

                                    this.loginService.authenticate(this.userToConnect).subscribe((credentialsAreFine) => {
                                            this.isAuthenticating = false;
                                            if (credentialsAreFine) {
                                                this.redirect();
                                            } else {
                                            }
                                        }, () => {
                                            this.isAuthenticating = false;
                                            this.toast.error();
                                        }
                                    );
                                });
                            // });
                        } else {
                            this.toast.error('Aucun utilisateur n\'est enregistré.');
                        }
                    },
                    error: (e) => {
                        console.error(e);
                        this.toast.error('server_error');
                    },
                });
            });
}
        }
    }


    reload() {
        this.verifierLocal();
    }

    send() {

        this.emitdata.emit(this.selection.selected);
    }


    redirect() {
        this.authService.isAchteur().subscribe((isachteur) => {
            if (isachteur) {
                this.router.navigateByUrl('/acheteur').then();
            }
        });
        this.authService.isFournisseur().subscribe((isFournisseur) => {
            if (isFournisseur) {
                this.router.navigateByUrl('/fournisseur').then();
            }
        });
        this.authService.isAdmin().subscribe((isAdmin) => {
            if (isAdmin) {
                this.router.navigateByUrl('/admin').then();
            }
        });
    }

    goToPortail() {
        this.router.navigateByUrl('/');
    }

    onPaginate(pagination: Pagination = this.paginationObject) {
        const start = pagination.offSet * pagination.limit;
        const end = start + pagination.limit;
        this.dataSource.data = [...this.certificates.slice(start, end)];
    }
}
